/* template */
<template><drawer-bottom :show="(show)" title="筛选" :customStyle="(drawerStyle)" @close="close" :showDefaultNav="(true)"><div class="es-filter-condition-container"><div class="es-filter-condition" v-if="(isTransfer)"><div class="es-filter-header">推荐筛选</div><div class="es-filter-type"><mpx-view v-for="(item, index) in (TRANSFER_STATION_TYPE)" :class="(transferStationType === item.type && 'select')" @tap.stop="selectFilterCondition('transfer_station_type', item.type)" class="es-filter-type-item">{{item.text}}</mpx-view></div></div><div class="es-filter-condition" v-if="(!isTransfer)"><div class="es-filter-header">特殊筛选</div><div class="es-filter-type"><mpx-view :class="(ticketsSelected && 'select')" @tap.stop="selectFilterCondition('preferred_tickets')" class="es-filter-type-item" v-if="(!isScramble && !isTransfer)">仅看有票</mpx-view><mpx-view :class="(isFxh && 'select')" @tap.stop="selectFilterCondition('is_fxh')" class="es-filter-type-item">复兴号</mpx-view><mpx-view :class="(isZN && 'select')" @tap.stop="selectFilterCondition('zndc')" class="es-filter-type-item">智能动车</mpx-view><mpx-view :class="(isStudent && 'select')" @tap.stop="selectFilterCondition('student')" class="es-filter-type-item">学生票</mpx-view><mpx-view :class="(isQuiet && 'select')" @tap.stop="selectFilterCondition('is_quiet')" class="es-filter-type-item">静音车厢</mpx-view></div></div><div class="es-filter-condition"><div class="es-filter-header">车型选择</div><div class="es-filter-type"><mpx-view v-for="(item, index) in (this.isTransfer ? TRANSFER_TRAIN_TYPE : TRAIN_TYPE)" :class="(trainType && trainType.includes(item.type) && 'select')" @tap.stop="selectFilterCondition('train_type_code', item.type)" class="es-filter-type-item">{{item.text}}</mpx-view></div></div><div class="es-filter-condition"><div class="es-filter-header">出发时间</div><div class="es-filter-type"><mpx-view v-for="(item, index) in (TRAIN_TIME)" :key="item.index" :class="(fromTime && fromTime.includes(item.queryTime[1]) && 'select')" @tap.stop="selectFilterCondition('start_time_list', item)" class="es-filter-type-item">{{ item.showTime }}</mpx-view></div></div><div class="es-filter-condition"><div class="es-filter-header">到达时间</div><div class="es-filter-type"><mpx-view v-for="(item, index) in (TRAIN_TIME)" :key="item.index" :class="(toTime && toTime.includes(item.queryTime[1]) && 'select')" @tap.stop="selectFilterCondition('end_time_list', item)" class="es-filter-type-item">{{ item.showTime }}</mpx-view></div></div><div class="es-filter-condition" v-if="(!isScramble)"><div class="es-filter-header">出发站点</div><div class="es-filter-type"><mpx-view v-for="(item, index) in (from_station_list)" :key="item.index" :class="(fromStation && fromStation.includes(item)  && 'select')" @tap.stop="selectFilterCondition('from_city_match', item)" class="es-filter-type-item">{{ item }}</mpx-view></div></div><div :style="[({marginBottom: '20px'})] | transRpxStyle" class="es-filter-condition" v-if="(!isScramble)"><div class="es-filter-header">到达站点</div><div class="es-filter-type"><mpx-view v-for="(item, index) in (to_station_list)" :key="item.index" :class="(toStation && toStation.includes(item) && 'select')" @tap.stop="selectFilterCondition('to_city_match', item)" class="es-filter-type-item">{{ item }}</mpx-view></div></div><div :style="[({marginBottom: '20px'})] | transRpxStyle" class="es-filter-condition" v-if="(isTransfer)"><div class="es-filter-header">中转城市</div><div class="es-filter-type"><mpx-view v-for="(item, index) in (transfer_station_list)" :key="item.index" :class="(transferStation && transferStation.includes(item) && 'select')" @tap.stop="selectFilterCondition('transfer_city_match', item)" class="es-filter-type-item" v-if="(transfer_station_list?.length)">{{ item }}</mpx-view></div></div><div class="footer-shadow"/></div><div class="es-filter-condition-container-footer"><mpx-view @tap.stop="resetSortCriteria" class="btn default">重置</mpx-view><mpx-view @tap.stop="search" class="btn primary">确定</mpx-view></div></drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m57b87110"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-filter-condition-container
    padding 8px 21px 0 20px
    overflow scroll
    .es-filter-condition
      margin-bottom 12px
      font-size 14px
      font-weight 400
      .es-filter-header
        margin-bottom 12px
        font-family PingFangSC-Medium
      .es-filter-type
        display grid 
        grid-template-columns: repeat(3, 1fr)
        grid-gap 8px
        justify-items center 
        align-items center
        .es-filter-type-item
          width 100%
          height 30px
          line-height 30px
          border-radius 6px
          background #fff
          text-align center 
          font-size 12px
          border 0.5px solid #CCCCCC
          color #666666
          font-family PingFangSC-Regular
        .es-filter-type-item.select
          color #222222
          border 0.5px solid #FF6400
          font-family PingFangSC-Medium
          position relative
          // overflow hidden
          &::after 
            content ''
            position absolute 
            bottom 0
            right 0
            width 10px
            height 10px
            background url('https://dpubstatic.udache.com/static/dpubimg/QbadIsbSV7H9PID73EIiG.png')
            background-size cover
  .footer-shadow
    height 88px
  .es-filter-condition-container-footer
    position fixed
    bottom 0
    width 100%
    height 88px
    padding-top 16px
    box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
    display flex
    background #ffffff
    justify-content space-between
    .btn
      width 100%
      height 50px
      border-radius 10px
      font-size 16px
      font-weight 500
      text-align center
      line-height 48px
      &.default
        color #333333
        background #fff
        border: 1px solid #CCCCCC
        margin-left 20px
        font-family PingFangSC-Medium
      &.primary
        color #ffffff
        background #FF6400
        margin-right 20px
        margin-left 11px
        font-family PingFangSC-Semibold
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m57b87110"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex57b87110%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex57b87110%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m57b87110"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index57b87110/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'drawer-bottom':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
